import { DefaultService } from '@/services/DefaultService';

export default class MailQueueService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getHistory(idcliente, page, limit, pedidos, param) {
        return  this._http.get(`${this._env}/mailqueue/${idcliente}/history?page=${page}&limit=${limit}&pedidos=${pedidos}&param=${param}`, this._headers)
                    .then(res => res.body, this.handleError);
    }

    getHistoryCount(idcliente, page, limit, pedidos, param) {
        return  this._http.get(`${this._env}/mailqueue/${idcliente}/history/count?page=${page}&limit=${limit}&pedidos=${pedidos}&param=${param}`, this._headers)
                    .then(res => res.body, this.handleError);
    }

    resendMail(ids) {
        return  this._http.get(`${this._env}/mailqueue/resend?ids=${ids.join(',')}`, this._headers)
                    .then(res => res.body, this.handleError);
    }

}